// ========================================
// CONSTANTES GLOBAIS - FileSave Dashboard
// ========================================
// Centralização de valores fixos para evitar hardcoding
// e facilitar manutenção e reutilização

// ========================================
// TIPOS DE PESSOA
// ========================================
export const PERSON_TYPES = {
    FISICA: 'NATURAL',
    JURIDICA: 'COMPANY'
};

export const PERSON_TYPE_LABELS = {
    [PERSON_TYPES.FISICA]: 'Pessoa Física',
    [PERSON_TYPES.JURIDICA]: 'Pessoa Jurídica'
};

// ========================================
// TIPOS DE PROPRIEDADE DE DOCUMENTO
// ========================================
export const DOCUMENT_OWNERSHIP = {
    COMPANY: 'empresa',
    CLIENT: 'cliente'
};

// ========================================
// TIPOS DE ORGANIZAÇÃO DE ARQUIVOS
// ========================================
export const ORGANIZATION_TYPES = {
    CATEGORY: 'categoria',
    TYPE: 'tipo',
    COMPANY: 'empresa'
};

export const ORGANIZATION_OPTIONS = [
    {
        value: ORGANIZATION_TYPES.TYPE,
        label: 'Por Tipo',
        icon: 'list'
    },
    {
        value: ORGANIZATION_TYPES.CATEGORY,
        label: 'Por Categoria',
        icon: 'folder-open'
    },
    {
        value: ORGANIZATION_TYPES.COMPANY,
        label: 'Por Empresa',
        icon: 'office'
    }
];

// ========================================
// VARIANTES DE COMPONENTES
// ========================================
export const BOX_VARIANTS = {
    DEFAULT: 'default',
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    SUCCESS: 'success',
    WARNING: 'warning',
    DANGER: 'danger',
    INFO: 'info'
};

export const ALERT_VARIANTS = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error'
};

export const PLAN_BADGE_SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
};

// ========================================
// TIPOS DE PLANOS
// ========================================
export const PLAN_TYPES = {
    FREE: 'free',
    PERSONAL: 'personal',
    PROFESSIONAL: 'professional',
    ENTERPRISE: 'enterprise'
};

export const PLAN_CONFIG = {
    [PLAN_TYPES.PERSONAL]: {
        name: 'Pessoal',
        color: '#10b981'
    },
    [PLAN_TYPES.PROFESSIONAL]: {
        name: 'Profissional',
        color: '#3b82f6'
    },
    [PLAN_TYPES.ENTERPRISE]: {
        name: 'Empresarial',
        color: '#f59e0b'
    }
};

// ========================================
// STATUS DE ARQUIVOS
// ========================================
export const FILE_STATUS = {
    ACTIVE: 'active',
    EXPIRING: 'expiring',
    EXPIRED: 'expired',
    PENDING: 'pending',
    REJECTED: 'rejected'
};

// ========================================
// STATUS DE AUTOMAÇÃO
// ========================================
export const AUTOMATION_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    WAITING: 'waiting'
};

// ========================================
// TIPOS DE ACTIONS NO BOX COMPONENT
// ========================================
export const ACTION_TYPES = {
    BUTTON: 'button',
    SELECT: 'select',
    INPUT: 'input',
    TOGGLE: 'toggle',
    BUTTON_GROUP: 'button-group'
};

// ========================================
// TIPOS DE INPUT
// ========================================
export const INPUT_TYPES = {
    TEXT: 'text',
    EMAIL: 'email',
    PASSWORD: 'password',
    NUMBER: 'number',
    SEARCH: 'search',
    TEL: 'tel',
    URL: 'url'
};

// ========================================
// TAMANHOS DE ARQUIVO
// ========================================
export const FILE_SIZE_LIMITS = {
    SMALL: 2, // MB
    MEDIUM: 10, // MB
    LARGE: 50, // MB
    EXTRA_LARGE: 100 // MB
};

// ========================================
// FORMATOS DE ARQUIVO SUPORTADOS
// ========================================
export const SUPPORTED_FILE_FORMATS = {
    PDF: 'PDF',
    PNG: 'PNG',
    JPG: 'JPG',
    JPEG: 'JPEG',
    DOC: 'DOC',
    DOCX: 'DOCX',
    XLS: 'XLS',
    XLSX: 'XLSX'
};

// ========================================
// CONFIGURAÇÕES DE PAGINAÇÃO
// ========================================
export const PAGINATION_CONFIG = {
    DEFAULT_PAGE_SIZE: 10,
    PAGE_SIZE_OPTIONS: [5, 10, 20, 50, 100],
    MAX_PAGE_SIZE: 100
};

// ========================================
// DELAYS DE SIMULAÇÃO DE API
// ========================================
export const API_DELAYS = {
    FAST: { min: 300, max: 800 },
    NORMAL: { min: 800, max: 2000 },
    SLOW: { min: 2000, max: 4000 }
};

// ========================================
// CONFIGURAÇÕES DE RECURSOS POR PLANO
// ========================================
export const PLAN_RESOURCES = {
    [PLAN_TYPES.FREE]: {
        storage: { total: 1, unit: 'GB' },
        uploads: { total: 10, unit: 'unidades' },
        alerts: { total: 5, unit: 'unidades' },
        sharePages: { total: 2, unit: 'páginas' }
    },
    [PLAN_TYPES.PERSONAL]: {
        storage: { total: 10, unit: 'GB' },
        uploads: { total: 50, unit: 'unidades' },
        alerts: { total: 20, unit: 'unidades' },
        sharePages: { total: 5, unit: 'páginas' }
    },
    [PLAN_TYPES.PROFESSIONAL]: {
        storage: { total: 50, unit: 'GB' },
        uploads: { total: 100, unit: 'unidades' },
        alerts: { total: 25, unit: 'unidades' },
        sharePages: { total: 10, unit: 'páginas' }
    },
    [PLAN_TYPES.ENTERPRISE]: {
        storage: { total: 500, unit: 'GB' },
        uploads: { total: 500, unit: 'unidades' },
        alerts: { total: 100, unit: 'unidades' },
        sharePages: { total: 50, unit: 'páginas' }
    }
};

// ========================================
// MAPEAMENTO DE ÍCONES PARA TIPOS DE ARQUIVO
// ========================================
export const FILE_ICONS = {
    'CNH': 'credit-card',
    'RG': 'user',
    'CPF': 'user',
    'Título de Eleitor': 'users',
    'Passaporte': 'file-text',
    'Visto': 'file-text',
    'Carteira de Vacinação': 'file-text',
    'Comprovante de Residência': 'home',
    'Contrato': 'file-text',
    'Contrato de Aluguel': 'home',
    'CRLV': 'credit-card',
    'CNPJ': 'office',
    'Alvará': 'file-text',
    'Certidão': 'file-text',
    'Diploma': 'file-text',
    'Certificado': 'file-text'
};

// ========================================
// CONFIGURAÇÕES DE RESPONSIVIDADE
// ========================================
export const BREAKPOINTS = {
    XS: 0,
    S: 480,
    M: 768,
    L: 1024,
    XL: 1200,
    XXL: 1400
};

// ========================================
// MAPEAMENTO DE STATUS DE ARQUIVO
// ========================================
export const FILE_STATUS_LABELS = {
    [FILE_STATUS.ACTIVE]: 'Ativo',
    [FILE_STATUS.EXPIRING]: 'Vencendo',
    [FILE_STATUS.EXPIRED]: 'Vencido',
    [FILE_STATUS.PENDING]: 'Pendente',
    [FILE_STATUS.REJECTED]: 'Rejeitado'
};

// ========================================
// TIPOS DE ATIVIDADES DO SISTEMA
// ========================================
export const ACTIVITY_TYPES = {
    UPLOAD: 'upload',
    ALERT: 'alert',
    SHARE: 'share',
    DOWNLOAD: 'download',
    ACCESS: 'access'
};

export const ACTIVITY_ICONS = {
    [ACTIVITY_TYPES.UPLOAD]: 'upload',
    [ACTIVITY_TYPES.ALERT]: 'bell',
    [ACTIVITY_TYPES.SHARE]: 'share',
    [ACTIVITY_TYPES.DOWNLOAD]: 'download',
    [ACTIVITY_TYPES.ACCESS]: 'user',
    // Tipos adicionais para atividades específicas
    'urgent': 'warning',
    'approval': 'checkmark',
    'reminder': 'clock',
    'processing': 'sync',
    'backup': 'archive',
    'analysis': 'analytics'
};

// ========================================
// STATUS DE RESPOSTA DA API
// ========================================
export const API_STATUS = {
    SUCCESS: 'success',
    ERROR: 'error',
    LOADING: 'loading',
    IDLE: 'idle'
};

// ========================================
// CONFIGURAÇÕES DE TIMEOUT
// ========================================
export const TIMEOUTS = {
    NOTIFICATION: 5000, // 5 segundos
    TOAST: 3000, // 3 segundos
    API_REQUEST: 30000, // 30 segundos
    FILE_UPLOAD: 120000 // 2 minutos
};

// ========================================
// CORES DO MODAL HEADER
// ========================================
export const MODAL_HEADER_COLORS = {
    BLUE: 'blue',
    GREEN: 'green',
    RED: 'red',
    ORANGE: 'orange',
    PURPLE: 'purple',
    GRAY: 'gray'
};

// ========================================
// STATUS DE WEB LINKS
// ========================================
export const WEB_LINK_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    EXPIRED: 'expired'
};

export const WEB_LINK_STATUS_LABELS = {
    [WEB_LINK_STATUS.ACTIVE]: 'Ativo',
    [WEB_LINK_STATUS.INACTIVE]: 'Inativo',
    [WEB_LINK_STATUS.EXPIRED]: 'Expirado'
};

// ========================================
// TIPOS DE WEB LINKS
// ========================================
export const WEB_LINK_TYPES = {
    SHARE: 'share',
    UPLOAD: 'upload'
};

// ========================================
// GRUPOS DE DOCUMENTOS
// ========================================
export const DOCUMENT_GROUPS = {
    PERSONAL: 'pessoal',
    WORK: 'trabalho',
    FAMILY: 'familia',
    FINANCIAL: 'financeiro',
    HEALTH: 'saude',
    EDUCATION: 'educacao'
};

export const DOCUMENT_GROUP_LABELS = {
    [DOCUMENT_GROUPS.PERSONAL]: 'Pessoal',
    [DOCUMENT_GROUPS.WORK]: 'Trabalho',
    [DOCUMENT_GROUPS.FAMILY]: 'Família',
    [DOCUMENT_GROUPS.FINANCIAL]: 'Financeiro',
    [DOCUMENT_GROUPS.HEALTH]: 'Saúde',
    [DOCUMENT_GROUPS.EDUCATION]: 'Educação'
};

// ========================================
// CORES DE BOTÕES
// ========================================
export const BUTTON_COLORS = {
    BLUE: 'blue',
    GRAY: 'gray',
    GREEN: 'green',
    ORANGE: 'orange',
    RED: 'red'
};

// ========================================
// TAMANHOS DE COMPONENTES
// ========================================
export const COMPONENT_SIZES = {
    EXTRA_SMALL: 'xs',
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg',
    EXTRA_LARGE: 'xl'
};

// ========================================
// VARIANTES DE FILE CARD
// ========================================
export const FILE_CARD_VARIANTS = {
    DEFAULT: 'default',
    MINIMAL: 'minimal'
};

// ========================================
// MENSAGENS DE NOTIFICAÇÃO
// ========================================
export const NOTIFICATION_MESSAGES = {
    LINK_COPIED: 'Link copiado para a área de transferência!',
    COPY_FAILED: 'Erro ao copiar link!',
    SAVE_SUCCESS: 'Alterações salvas com sucesso!',
    SAVE_ERROR: 'Erro ao salvar alterações. Tente novamente.',
    UPLOAD_SUCCESS: 'Arquivo enviado com sucesso!',
    UPLOAD_ERROR: 'Erro ao enviar arquivo. Tente novamente.',
    DELETE_CONFIRM: 'Tem certeza que deseja excluir?',
    CONNECTION_ERROR: 'Erro de conexão. Tente novamente.'
};

// ========================================
// MENSAGENS DE EXPIRAÇÃO
// ========================================
export const EXPIRY_MESSAGES = {
    TODAY: 'Vence hoje',
    EXPIRED_DAYS: (days) => `Vencido há ${days} dia${days > 1 ? 's' : ''}`,
    EXPIRES_DAYS: (days) => `Vence em ${days} dia${days > 1 ? 's' : ''}`,
    VALID_DAYS: (days) => `Válido por ${days} dias`
};

// ========================================
// VARIANTES DE PLAN BADGE
// ========================================
export const PLAN_BADGE_VARIANTS = {
    DEFAULT: 'default',
    NAVBAR: 'navbar'
};

// ========================================
// MODAL DE CONFIRMAÇÃO DE EXCLUSÃO
// ========================================
export const DELETE_MODAL_CONFIG = {
    ICON: 'bin',
    COLOR: 'red',
    TITLE: 'Excluir Link de Compartilhamento',
    SUBTITLE: 'Esta ação não pode ser desfeita'
};

export const DELETE_MODAL_MESSAGES = {
    CONFIRM_WARNING: 'O link será desativado e não poderá mais ser acessado. Os arquivos originais permanecerão seguros em sua conta.',
    SUCCESS: 'Link de compartilhamento excluído com sucesso!',
    ERROR: 'Erro ao excluir link. Tente novamente.',
    BUTTON_CANCEL: 'Cancelar',
    BUTTON_DELETE: 'Excluir Link'
};

// ========================================
// AÇÕES DE MODAL
// ========================================
export const MODAL_ACTIONS = {
    CONFIRM: 'confirm',
    CANCEL: 'cancel',
    DELETE: 'delete'
};

// ========================================
// OPÇÕES DE AUTOMAÇÃO
// ========================================
export const AUTOMATION_FREQUENCY_OPTIONS = [
    { value: 'once', label: 'Uma vez' },
    { value: 'daily', label: 'Diário' },
    { value: 'weekly', label: 'Semanal' },
    { value: 'monthly', label: 'Mensal', selected: true }
];

export const AUTOMATION_WEEKDAYS = [
    { value: 'monday', label: 'Seg' },
    { value: 'tuesday', label: 'Ter' },
    { value: 'wednesday', label: 'Qua' },
    { value: 'thursday', label: 'Qui' },
    { value: 'friday', label: 'Sex' },
    { value: 'saturday', label: 'Sáb' },
    { value: 'sunday', label: 'Dom' }
];

export const AUTOMATION_MONTHLY_TYPE_OPTIONS = [
    { value: 'day', label: 'Dia específico do mês', selected: true },
    { value: 'last', label: 'Último dia do mês' }
];

export const AUTOMATION_FILE_SELECTION_OPTIONS = [
    { value: 'type', label: 'Tipo de Documento', selected: true },
    { value: 'category', label: 'Categoria' },
    { value: 'client', label: 'Empresa' }
];

// ========================================
// TIPOS DE AUTOMAÇÃO
// ========================================
export const AUTOMATION_TYPES = {
    EMAIL: 'email',
    NOTIFICATION: 'notification',
    BACKUP: 'backup',
    REMINDER: 'reminder'
};

export const AUTOMATION_TRIGGER_TYPES = {
    SCHEDULED: 'scheduled',
    UPLOAD: 'upload',
    EXPIRATION: 'expiration',
    MANUAL: 'manual'
};

// ========================================
// CONFIGURAÇÕES DE AUTOMAÇÃO
// ========================================
export const AUTOMATION_CONFIG = {
    MAX_RECIPIENTS: 50,
    MAX_FILES_PER_AUTOMATION: 100,
    MIN_FREQUENCY_INTERVAL: 1, // horas
    MAX_FREQUENCY_INTERVAL: 8760, // horas (1 ano)
    DEFAULT_TIME: '09:00',
    SUPPORTED_EMAIL_FORMATS: ['gmail.com', 'outlook.com', 'yahoo.com', 'hotmail.com']
};

// ========================================
// ALERTAS INTELIGENTES DE VENCIMENTO
// ========================================
export const ALERT_TRIGGER_DAYS = [60, 30, 15, 7, 3, 1];

export const ALERT_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    URGENT: 'urgent'
};

export const ALERT_STATUS_LABELS = {
    [ALERT_STATUS.ACTIVE]: 'Ativo',
    [ALERT_STATUS.INACTIVE]: 'Inativo',
    [ALERT_STATUS.URGENT]: 'Urgente'
};

export const ALERT_URGENCY_LEVELS = {
    SAFE: 'safe',        // > 60 dias para vencer
    WARNING: 'warning',  // 30-60 dias para vencer
    CRITICAL: 'critical' // < 30 dias para vencer ou vencido
};

export const ALERT_NOTIFICATION_CHANNELS = {
    EMAIL: 'email',
    WHATSAPP: 'whatsapp',
    SMS: 'sms'
};

export const ALERT_CONFIG = {
    DEFAULT_TRIGGER_DAYS: [30, 15, 7, 3, 1],
    MAX_TRIGGER_DAYS: 365,
    MIN_TRIGGER_DAYS: 1,
    DEFAULT_TIME: '09:00',
    MAX_RECIPIENTS_PER_ALERT: 10
};